export default {
  selectedDestination(state) {
    const index = state.selectedDestination;
    const destinations = state.destinations;
    return index > -1 && destinations[index] ? destinations[index] : null;
  }
};
